import type BookingService from 'owa-service/lib/contract/BookingService';

// The duration and preBuffer are added to the follow-up offset during create/update of a meeting, as in the backend mails are sent
// with respect to the start time of the meeting. Here we are reverting that logic to display the correct offset on the UI.
export default function correctFollowUpTime(BookingService: BookingService) {
    const inboxRemindersArray = BookingService?.InboxReminders;
    if (inboxRemindersArray && inboxRemindersArray.length > 0) {
        inboxRemindersArray.forEach(inboxReminder => {
            if (
                inboxReminder &&
                inboxReminder.ReminderOffset !== undefined &&
                inboxReminder?.ReminderOffset < 0
            ) {
                const preBuffer = BookingService?.PreBuffer ?? 0;
                const defaultDurationMinutes = BookingService?.DefaultDurationMinutes ?? 0;
                inboxReminder.ReminderOffset += defaultDurationMinutes + preBuffer;
            }
        });
    }
    return BookingService;
}
